import { useResilientQuery } from '@famly/stat_apollo-query';
import { useImmerQueryWrapper } from './use-immer-query-wrapper';
/**
 * Simply combines the `useResilientQuery` with the `useImmerQueryWrapper`.
 *
 * @see useResilientQuery
 * @see useImmerQueryWrapper
 */
export function useStatQuery(query, options) {
    return useImmerQueryWrapper(useResilientQuery(query, options), { skip: options === null || options === void 0 ? void 0 : options.skip });
}
